export default "__VITE_ASSET__Xc29ajLQ__"